import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { solid } from "@fortawesome/fontawesome-svg-core/import.macro";

import { REQUEST_STATUS } from "../../../../models/EnrollmentHistoryDTO";

/** Otra persona de la matrícula grupal (misma bundle_key). */
export interface PersonaJunta { id: number; name: string; statusId: number; status: string; }
/** Cliente de la misma Solicitud que todavía no tiene matrícula. */
export interface ClientePendiente { personId: number; nombre: string; }

interface PersonasJuntasProps {
	nombre: string;
	juntas: PersonaJunta[];
	pendientes: ClientePendiente[];
	busy: boolean;
	onAgregar?: () => void;
	onAbrir?: (requestId: number) => void;
	onCompletar?: (personId: number) => void;
}

/*
	Varias personas en una sola matrícula (Esteban, 2026-10-27: "deben poderse hacer para 2+ personas de un jalón, con datos para todos
	los alumnos ahora que se ponen los descuentos, por los grupos"). Arriba de cada paso: quiénes van juntas, cambiar de una a otra
	sin salir de la ventana y agregar a alguien más. Juntas = se aprueban juntas, un solo ticket a Caja y las promos de grupo
	(«Grupo de 3/4», «50 % · 2da persona») las encuentran.
*/
const PersonasJuntas: React.FC<PersonasJuntasProps> = ({ nombre, juntas, pendientes, busy, onAgregar, onAbrir, onCompletar }) => {
	const total = 1 + juntas.length + pendientes.length;
	return (
		<div className="waJuntas" role="group" aria-label="Personas en esta matrícula">
			<span className="waJuntasTitulo"><FontAwesomeIcon icon={solid("users")} />&nbsp;{total > 1 ? `${total} Personas Juntas` : "Personas"}</span>
			<span className="waJunta actual" aria-current="true"><FontAwesomeIcon icon={solid("user-pen")} />{nombre || "Esta persona"}</span>
			{juntas.map((j) => (
				<button type="button" key={"j" + j.id} className="waJunta" disabled={busy || !onAbrir} onClick={() => onAbrir?.(j.id)}
					title={`Matrícula #${j.id} · ${j.status}`}>
					<FontAwesomeIcon icon={j.statusId === REQUEST_STATUS.BORRADOR || j.statusId === REQUEST_STATUS.DEVUELTA ? solid("user") : solid("user-check")} />
					{j.name}<small>{j.status}</small>
				</button>
			))}
			{pendientes.map((p) => (
				<button type="button" key={"p" + p.personId} className="waJunta pendiente" disabled={busy || !onCompletar} onClick={() => onCompletar?.(p.personId)}
					title="Guarda esta y sigue con este cliente">
					<FontAwesomeIcon icon={solid("user-plus")} />{p.nombre}<small>Por completar</small>
				</button>
			))}
			{onAgregar ? (
				<button type="button" className="waJuntasAgregar" disabled={busy} onClick={onAgregar}>
					<FontAwesomeIcon icon={solid("plus")} />&nbsp;Agregar Persona
				</button>
			) : null}
		</div>
	);
};

export default PersonasJuntas;
